import produce from 'immer'
import {
  MARK_BUYER_FOR_UNSUBSCRIBE,
  UNMARK_BUYER_FOR_UNSUBSCRIBE
} from 'src/actions/actionTypes'

export const initialState = {
  requested: false
}

export default (state = initialState, { type }) =>
  produce(state, draft => {
    switch (type) {
      case MARK_BUYER_FOR_UNSUBSCRIBE: {
        draft.requested = true
        return draft
      }
      case UNMARK_BUYER_FOR_UNSUBSCRIBE: {
        draft.requested = false
        return draft
      }
      default:
        break
    }
  })
